import { CommonFeaturePageValues, Document } from 'store/products/types'

export const toDocumentBasedFormValues = (feature: Document[], keyName: string): CommonFeaturePageValues => {
  const formWithValues = {}
  formWithValues[keyName] = feature || ([] as Document[])
  return formWithValues
}

export const hasDocumentBasedFeature = (feature: Document[]): boolean => Array.isArray(feature) && feature.length > 0
